import React from 'react';

import loadingSpinner from '../../images/icons/loader.png';
import './loader-utils.scss';

const Loader = ({ loading }) => {
  return loading ? (
    <div className="loader-container">
      <img src={loadingSpinner} alt="Loading" />
    </div>
  ) : null;
};

const NoResult = ({ noResult, type }) => {
  const textMap = {
    article_graph: 'No articles selected.',
    barometers: 'No barometer stats available.',
    'campaign-center-budget-table': 'No Budgets have been created.',
    'campaign-center-campaigns-table': 'No Campaigns available.',
    'cart-carousel': 'No bought-with products found.',
    'cart-explorer': 'No product data found. Please select a different product.',
    earnings:
      'Earnings are the total amount of money you’ve made on Narrativ. Once you start earning on ' +
      'Narrativ, you can track the status of those Earnings to see how much you’re expected to be paid.',
    'earnings-graph': 'Insufficient graph data.',
    'megatable-articles': 'No articles found. Please modify date range.',
    'megatable-smartlinks': 'No Smartlinks found. Please modify date range.',
    'megatable-products': 'No products found. Please modify date range.',
    'megatable-merchantArticles': 'No articles found. Please modify date range.',
    'megatable-merchantRecommendations': 'No recommendations found. Please modify date range.',
    'megatable-merchantTopPublishers': 'No publishers found',
    'merch-ed-overview': 'No merchants found',
    'merchant-overview': 'No merchant overview data available.',
    'minitable-merchant_epc': 'No stats available.',
    'minitable-merchant_clicks': 'No stats available.',
    'minitable-feed_difference_counts':
      'No differences for this merchant. ' + 'The feed most likely ran successfully.',
    'minitable-feed_differences_by_field':
      'No differences for this field name. ' + 'The feed most likely does not contain this field.',
    'no-columns': 'Select columns from the dropdown',
    payouts:
      'Payouts are earnings that have already been deposited to your account.' +
      'You’ll start receiving Payouts approximately 90 days after you start earning on Narrativ.',
    'orders-page': 'No orders found.',
    'product-trends': 'No best sellers found. Please select a different merchant.',
    'items-on-sale': 'No items on sale found. Please select a different merchant.',
    'new-products': 'No new products found. Please select a different merchant.',
    'publisher-overview': 'No publisher overview data available.',
    'search-trends': 'No search trends found. Please select a different merchant.',
    'top-articles': 'No stories available.',
    'total-earnings': 'No earnings stats available.',
    'total-revenue': 'No revenue stats available.',
    'strategy-typeahead': 'No results found.',
    'strategy-performance': 'This strategy has no data in selected date range.',
    'strategy-performance-tab-graph': 'No Rows Selected For Graph',
  };

  return noResult ? <div className="no-result">{textMap[type]}</div> : null;
};

export { Loader, NoResult };
